import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setGlobalLoader } from "../../../redux/slices/globalLoader";
import { setUserType } from "../../../redux/slices/userType";
import { addData } from "../../../redux/slices/globalDetails";
import GlobalLoader from "./globalLoader";
import offlineImg from "../../../assets/Offline.jpeg";
import { getUser } from "../../../utils/commonfunction";
import { ROLE } from "../../../utils/Constants";

const BusinessProfileLayout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loaderState = useSelector((state) => state.globalLoader);

  const offlineModalOpen = useRef(null);
  const offlineModalClose = useRef(null);

  const isNetworkConnected = async () => {
    const response = await fetch("https://www.google.com/", { mode: "no-cors" });
    offlineModalClose.current?.click();
  };

  const handleOnline = () => {
    offlineModalClose.current?.click();
  };

  const handleOffline = () => {
    offlineModalOpen.current?.click();
  };

  useEffect(() => {
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  useLayoutEffect(() => {
    dispatch(setUserType("business"));
    Promise.all([import("../../../assets/business/css/style.css"), import("../../../assets/business/css/responsive.css")]).then(() => {
      dispatch(setGlobalLoader(false));
    });
  }, []);

  useEffect(() => {
    const data = getUser(ROLE.BUSINESS);
    if (data?.isCompleteProfile) {
      navigate("/business/dashboard");
    }
  }, [navigate]);

  return (
    <>
      {/* Offline Modal Trigger Button */}
      <button type="button" ref={offlineModalOpen} className="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#staticBackdrop"></button>

      {/* Offline Modal */}
      <div className="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content offline-modal-content">
            <button type="button" className="btn-close d-none" ref={offlineModalClose} data-bs-dismiss="modal" aria-label="Close"></button>
            <div className="modal-body">
              <div className="w-100 d-flex justify-content-center py-5">
                <div className="text-center">
                  <img className="offline-modal-img" src={offlineImg} alt="Offline" />
                  <h3 className="fs-22">No Internet Connection</h3>
                  <p>Check your internet connection and try again.</p>
                  <button onClick={isNetworkConnected} className="btn btn-primary mt-2">
                    Try Again
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Page Content */}
      {loaderState ? (
        <GlobalLoader />
      ) : (
        <div className="page">
          <Outlet />
        </div>
      )}
    </>
  );
};

export default BusinessProfileLayout;
